import React from "react";
import { PageHeader } from "@shared/components/PageHeader";
import { StripeConfigForm } from "../create/create";

const StripeLanding = () => {
  return (
    <div className="space-y-6">
      <StripeConfigForm />
    </div>
  );
};

export default StripeLanding;
